import {
    getUserSubscriptionType,
    getUserSubscriptionStatus,
    sha256,
    isUserLoggedIn
} from '../tools/utilities';

/**
 * @param {string} event 
 * @param {array} items 
 */
export function ga4TrackingEcommerce(event, items)  {
    if (Array.isArray(items) && items.length > 0) {
        let total = items.reduce((prevItem, currentItem) => {
            const quantity = 'quantity' in currentItem && currentItem?.quantity ? currentItem?.quantity : 1;
            return prevItem + (currentItem.price * quantity);
        }, 0);

        // If from Pelcro as Stripe doesn't store prices as decimals so need to divide by 100 e.g. 19.99 is stored as 1999
        if (total > 0 && total % 1 == 0) {
            total = total / 100;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: event,
            affiliation: 'Pelcro',
            type: 'ecommerce',
            ecommerce: {
                currency: items[0].currency.toUpperCase(),
                value: parseFloat(total.toFixed(2)),
                items: items.map(
                    item => {
                        // Need to handle fetching data from OpenSearch or Pelcro data
                        let category = 'inventory_description' in item && item?.inventory_description !== null && item.inventory_description !== ''
                            ? item?.inventory_description
                            : '';
                        if ('description' in item && item?.description !== null && item?.description !== '') {
                            category = item?.description;
                        }

                        let inStock = true;
                        if ('inStock' in item && item?.inStock !== null) {
                            inStock = item?.inStock;
                        } else if ('inventory_type' in item && item?.inventory_type !== null) {
                            inStock = item.inventory_type != 1 || (item.inventory_type == 1 && item.inventory_quantity > 0);
                        }

                        let price = item.price;
                        // If from Pelcro as Stripe doesn't store prices as decimals so need to divide by 100 e.g. 19.99 is stored as 1999
                        if (item.price > 0 && item.price % 1 == 0) {
                            price = item.price / 100;
                        }

                        return {
                            item_id: item.id,
                            item_name: item.name,
                            item_category: category,
                            item_variant: item.name,
                            item_in_stock: inStock ? 'yes' : 'no',
                            price: price,
                            quantity: 'quantity' in item && item?.quantity ? item?.quantity : 1
                        };
                    }
                )
            }
        });
    }
}

/**
 * @param {string} event 
 * @param {array} items 
 */
export function ga4TrackingSubscription(event, items)  {
    if (Array.isArray(items) && items.length > 0) {
        let total = items.reduce((prevItem, currentItem) => prevItem + currentItem.amount, 0);
        total = total > 0
            ? total / 100
            : 0;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: event,
            affiliation: 'Pelcro',
            type: 'subscription',
            ecommerce: {
                currency: items[0].currency.toUpperCase(),
                value: parseFloat(total.toFixed(2)),
                items: items.map(
                    item => {
                        const price = item.amount > 0
                            ? item.amount / 100
                            : 0;

                        return {
                            item_id: item.id,
                            item_name: item.name_internal,
                            item_category: item.description,
                            item_variant: item.nickname,
                            item_in_stock: 'yes',
                            price: price,
                            quantity: 1
                        };
                    }
                )
            }
        });
    }
}

document.addEventListener('PelcroSubscriptionCreate', (response, e) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'subscribedStatus': getUserSubscriptionStatus(),
        'subscriberType': getUserSubscriptionType(), // will be 'Digital', 'Bundle' or 'NoSub'
    });

    // if (typeof fbq == 'function' && response?.detail?.data?.subscriptions.length > 0) {
    //     fbq('track', 'Subscribe', {
    //         currency: response.detail.data.subscriptions[response.detail.data.subscriptions.length - 1].plan.currency.toUpperCase(),
    //         value: value,
    //         predicted_ltv: value * response.detail.data.subscriptions[response.detail.data.subscriptions.length - 1].plan.interval_count,
    //         contents: [
    //             {
    //                 id: response.detail.data.subscriptions[response.detail.data.subscriptions.length - 1].plan.id,
    //                 quantity: 1
    //             }
    //         ],
    //         content_ids: [
    //             response.detail.data.subscriptions[response.detail.data.subscriptions.length - 1].plan.id
    //         ],
    //         content_type: 'product'
    //     });
    // }
});

// document.addEventListener('PelcroOrderCreated', (response, e) => {
//     if (typeof fbq == 'function' && response?.detail) {
//         fbq('track', 'Purchase', {
//             currency: response.detail.currency.toUpperCase(),
//             value: response.detail.amount > 0
//                 ? response.detail.amount / 100
//                 : 0, // Stripe doesn't store prices as decimals so need to divide by 100 e.g. 19.99 is stored as 1999
//             contents: response.detail.items.map(
//                 item => {
//                     return {
//                         id: item.product_sku_id,
//                         quantity: item.quantity
//                     };
//                 }
//             ),
//             content_ids: response.detail.items.map(
//                 item => item.product_sku_id
//             ),
//             content_type: 'product'
//         });
//     }
// });

document.addEventListener('PelcroElementsCartItemAdded', (response, e) => {
    if (response?.detail) {
        ga4TrackingEcommerce('add_to_cart', [response.detail]);

        // if (typeof fbq == 'function') {
        //     const price = response.detail.amount > 0
        //         ? response.detail.amount / 100
        //         : 0;
        //     fbq('track', 'AddToCart', {
        //         currency: response.detail.currency.toUpperCase(),
        //         value: price, // Stripe doesn't store prices as decimals so need to divide by 100 e.g. 19.99 is stored as 1999
        //         contents: [
        //             {
        //                 id: response.detail.id,
        //                 quantity: 1
        //             }
        //         ],
        //         content_ids: [
        //             response.detail.id
        //         ],
        //         content_name: response.detail.name,
        //         content_type: 'product'
        //     });
        // }

        const headerBasketButton = document.querySelector('[data-target="header-basket-button"]');
        if (headerBasketButton !== null) {
            setTimeout(() => {
                headerBasketButton.click();
            }, 500);
        }
    }
});

document.addEventListener('PelcroElementsCartOpened',  (response, e) =>  {
    ga4TrackingEcommerce('view_cart', response.detail);
});

document.addEventListener('PelcroPaywallDisplayed', () => {
    const paywallType = pelcro_details && 'paywall_type' in pelcro_details && pelcro_details.paywall_type != ''
        ? pelcro_details.paywall_type
        : 'none';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'content_paywall_blocked',
        contentRestricted: 'true',
        paywallBannerType: `${paywallType}`,
    });
});

document.addEventListener('PelcroUserRegister', async (response, e) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'Registered',
        loggedInStatus: 'true',
        loggedInUserID: `${response?.detail?.data?.id}`,
        subscribedStatus: getUserSubscriptionStatus(),
        subscriberType: getUserSubscriptionType(), // will be 'Digital', 'Bundle' or 'NoSub'
        user_data: {
            email: `${response?.detail?.data?.email}`,
            sha256_email_address: await sha256(`${response?.detail?.data?.email}`),
        },
    });

    // if (typeof fbq == 'function' && response?.detail?.data) {
    //     fbq('track', 'CompleteRegistration', {
    //         currency: response.detail.data.currency.toUpperCase(),
    //         value: 0,
    //         status: true
    //     });
    // }
});

document.addEventListener('PelcroUserLoggedIn', async (response, e) => {
    if (response?.detail?.data?.id) {
        let date = new Date();
        date.setTime(date.getTime() + 60 * 24 * 60 * 60 * 1000);
        document.cookie = `pelcro_user_id=${response?.detail?.data?.id}; path=/; expires=${date.toUTCString()}; Secure`;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'Logged in',
            loggedInStatus: 'true',
            loggedInUserID: `${response?.detail?.data?.id}`,
            subscribedStatus: getUserSubscriptionStatus(),
            subscriberType: getUserSubscriptionType(), // will be 'Digital', 'Bundle' or 'NoSub'
            user_data: {
                email: `${response?.detail?.data?.email}`,
                sha256_email_address: await sha256(`${response?.detail?.data?.email}`),
            },
        });
    }
});

document.addEventListener('PelcroUserLogout', () => {
    document.cookie = 'pelcro_user_id=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; Secure';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'Logged out',
        loggedInStatus: 'false',
        loggedInUserID: '',
        subscribedStatus: 'false',
        subscriberType: 'NoSub',
        user_data: {
            email: '',
            sha256_email_address: '',
        },
    });
});

document.addEventListener('PelcroUserLoaded', async (response, e) => {
    if (response?.detail?.data?.id) {
        let date = new Date();
        date.setTime(date.getTime() + 60 * 24 * 60 * 60 * 1000);
        document.cookie = `pelcro_user_id=${response?.detail?.data?.id}; path=/; expires=${date.toUTCString()}; Secure`;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'user_info_added',
            loggedInStatus: 'true',
            loggedInUserID: `${response?.detail?.data?.id}`,
            subscribedStatus: getUserSubscriptionStatus(),
            subscriberType: getUserSubscriptionType(),
            user_data: {
                email: `${response?.detail?.data?.email}`,
                sha256_email_address: await sha256(`${response?.detail?.data?.email}`),
            },
        });
    }
});

if (!isUserLoggedIn()) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'user_info_added',
        loggedInStatus: 'false',
        loggedInUserID: '',
        subscribedStatus: 'false',
        subscriberType: 'NoSub',
        user_data: {
            email: '',
            sha256_email_address: '',
        },
    });
}
